import React, { useEffect, useState } from "react";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import {
    capitalLetter,
    classNameInput,
    dateAddDays,
    dateToString,
    notify,
} from "../../../utils/utils";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { useMovimientos } from "../../../hooks/almacen/useMovimientos";
import { DatePickerABX } from "../../components/pickers/DatePicker";
import { useModal } from "../../../hooks/useModal";
import { Modal } from "../../components/modal/Modal";
import { useUnidades } from "../../../hooks/gestionMantenimientos/useUnidades";
import { useSettings } from "../../../hooks/gestionMantenimientos/useSettings";
import { useNeumaticos } from "../GestionNeumaticos/useNeumaticos";
import { useBloqueoPantalla } from "../../../hooks/useBloqueoPantalla";

export const SalidaPorOT = () => {
    const estadosSalidaOrdenTrabajo = {
        9: "bg-yellow-600", // PENDIENTE
        18: "bg-green-600", // ATENDIDO
        37: "bg-[#5cb85c]", // AUTORIZADO
        39: "bg-[#c0c0c0]", // FINALIZADO
    };
    const movimientoInfoDefault = {
        codOrdenTrabajo: 0,
        codDiagnosticoTaller: 0,
        fechaOrdenTrabajo: "",
        codDocumento: 0,
        numDocumentoOT: "",
        codUnidad: 0,
        unidad: "",
        codPersonaConductor: 0,
        nomPersonaConductor: "",
        codEstado: 0,
        nomEstado: "",
        codUsuarioCreacion: 0,
        nomUsuarioCreacion: "",
        repuestoDetalle: "",

        comentario: "",
        codSolicitante: 0,
    };
    const editarValorMovimientoInfo = (key, value) => {
        setMovimientoInfo((valorAnterior) => {
            return {
                ...valorAnterior,
                [key]: value,
            };
        });
    };

    const {
        listarDiagnosticoTaller,
        diagnosticosTaller,
        movimientoDefault,
        registrarSalidaPorOT,
        personasTaller,
        listarComboPersonasTaller
    } = useMovimientos();

    const [textoFiltro,setTextoFiltro] = useState('')
    const [fechaInicio, setFechaInicio] = useState(dateAddDays(-30));
    const [fechaFin, setFechaFin] = useState(new Date());
    const [movimientoInfo, setMovimientoInfo] = useState(movimientoInfoDefault);
    const [codigoProdSeleccionadoSerie, setCodigoProdSeleccionadoSerie] = useState(0);
    const [seriesModalSalida, setSeriesModalSalida] = useState({});
    const [bloquearPantalla, desbloquearPantalla, ComponenteBloqueo] = useBloqueoPantalla();
    const { unidadesActivas, listadoUnidadesActivas } = useUnidades();
    const { listarConductores, conductores } = useSettings();
    const [isOpenSalidaOT, openSalidaOT, closeSalidaOT] = useModal();
    const [isOpenModalSeriesSalida,openModalSeriesSalida,closeModalSeriesSalida] = useModal();
    const {
        listarRepuestoCodigos, // OBTIENE LAS SERIES DE LOS NEUMATICOS (SOLO LOS NEUMATICOS TIENEN SERIE¿¿¿)
        repuestosCodigos,

        listarSeriesNeumaticosConMedida,
        seriesNeumaticosConMedida,
    } = useNeumaticos();

    useEffect(() => {
        const funcionReady = async () => {
            bloquearPantalla()
            await listarComboPersonasTaller()
            await listadoUnidadesActivas();
            await listarConductores();
            await funcionListarTabla();
            desbloquearPantalla()
        };
        funcionReady();
    }, []);

    const funcionListarTabla = async () => {
        bloquearPantalla()
        await listarDiagnosticoTaller(
            dateToString(fechaInicio),
            dateToString(fechaFin),
            0
        );
        desbloquearPantalla()
    };

    const funcionConfirmarSalidaPorOT = async () => {
        // VALIDACION PARA VER SI REGISTRAR LAS SERIES SOLICITADAS
        const isRegistroIncompleto = movimientoInfo.repuestoDetalle
            .split("~")
            .some((elem) => {
                const concatenadosRepuestos = elem.split("*");
                if (concatenadosRepuestos[4] == 1) {
                    if (concatenadosRepuestos[6]) {
                        return (
                            Number(concatenadosRepuestos[3]) !=
                            Number(concatenadosRepuestos[6].split(",").length)
                        );
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            });

        if (isRegistroIncompleto) {
            notify("Elegir todas las series para los productos", "info");
            return;
        }

        if (!movimientoInfo.codSolicitante) {
            notify("Elegir el solicitante", "info");
            return;
        }
        // FIN VALIDACION

        const jsonData = await registrarSalidaPorOT({
            codPersonaEntrega: parseInt(movimientoInfo.codSolicitante),
            codOrdenTrabajo: movimientoInfo.codOrdenTrabajo,
            comentarioSalidaPedido: movimientoInfo.comentario,
            pedidoDetalle: movimientoInfo.repuestoDetalle
                .split("~")
                .map((data, i) => {
                    const partes = data.split("*");
                    return {
                        codRepuesto: parseInt(partes[0]),
                        cantidad: parseInt(partes[3]),
                        series:
                            partes[4] == 1
                                ? partes[6].split(",").map((data) => {
                                      return {
                                          codSerieRepuesto: data,
                                      };
                                  })
                                : [],
                    };
                }),
        });
        notify(
            jsonData.DesResultado,
            jsonData.CodResultado == 1 ? "success" : "error"
        );
        if (jsonData.CodResultado == 1) {
            closeSalidaOT();
            await funcionListarTabla();
        }
    };

    return (
        <>
            <div className="w-full h-full flex flex-col">
                <ComponenteBloqueo></ComponenteBloqueo>
                <ContenedorParametros titulo="Salida por OT" tablaId={'tbSalidas'}>
                    <input value={textoFiltro} onChange={e => setTextoFiltro(e.target.value)} placeholder="(Buscar por OT)" type="text" className={`${classNameInput} w-[250px]`} />
                    <BotonProcesar onClick={funcionListarTabla}></BotonProcesar>
                </ContenedorParametros>

                <div className="flex-grow mt-7 overflow-auto containerScroll">
                    <table className="tableResponsive" id="tbSalidas">
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>FECHA</th>
                                <th>CÓDIGO</th>
                                <th>UNIDAD</th>
                                <th>CONDUCTOR</th>
                                <th>DETALLE</th>
                                <th>U.CREACIÓN</th>
                                <th></th>
                                <th>ESTADO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {diagnosticosTaller.length != 0 ? (
                                diagnosticosTaller
                                    .filter((e) => e.repuestoDetalle)
                                    .filter(e => e.numDocumentoOT.toLowerCase().includes(textoFiltro.toLowerCase()))
                                    .map((data, i) => {
                                        // FILTRANDO SOLO CUANDO TENGA "REPUESTO DETALLE" (SE EXCLUYE LOS SERVICIOS)
                                        const concatenadoProductos =
                                            data.repuestoDetalle
                                                .split("~")
                                                .map((e) => {
                                                    const partes = e.split("*");
                                                    return `(${partes[3]}) ${partes[1]}`;
                                                })
                                                .join(", ") || "-";
                                        return (
                                            <tr key={i + 1}>
                                                <td className="">
                                                    {i + 1}
                                                </td>
                                                <td
                                                    data-label="Fecha"
                                                    className=" whitespace-nowrap"
                                                >
                                                    {data.fechaOrdenTrabajo ||
                                                        "-"}
                                                </td>
                                                <td
                                                    data-label="Código"
                                                    className=" whitespace-nowrap"
                                                >
                                                    {data.numDocumentoOT || "-"}
                                                </td>
                                                <td
                                                    data-label="Unidad"
                                                    className=" whitespace-nowrap"
                                                >
                                                    {data.unidad || "-"}
                                                </td>
                                                <td
                                                    data-label="Conductor"
                                                    className=" whitespace-nowrap"
                                                >
                                                    {data.nomPersonaConductor || "-"}
                                                </td>
                                                <td
                                                    data-label="Detalle"
                                                    title={concatenadoProductos}
                                                    className="text-left whitespace-nowrap max-w-[300px] overflow-hidden text-ellipsis"
                                                >
                                                    {concatenadoProductos}
                                                </td>
                                                <td
                                                    data-label="U.Creación"
                                                    className=" whitespace-nowrap"
                                                >
                                                    {data.nomUsuarioCreacion ||
                                                        "-"}
                                                </td>
                                                
                                                <td
                                                    data-label="Opciones"
                                                    className="text-center whitespace-nowrap"
                                                >
                                                    {data.codEstadoSuministroAlmacen ==
                                                    9 ? (
                                                        <button
                                                            onClick={() => {
                                                                openSalidaOT();
                                                                setMovimientoInfo(
                                                                    Object.assign(
                                                                        {},
                                                                        movimientoDefault,
                                                                        data
                                                                    )
                                                                );
                                                            }}
                                                            className="!h-[20px] text-xs px-1 rounded bg-green-600"
                                                        >
                                                            <i
                                                                className="fa fa-check"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button>
                                                    ) : (
                                                        ""
                                                    )}
                                                </td>
                                                <td
                                                    data-label="Estado"
                                                    className="!flex items-center justify-between"
                                                >
                                                    <div
                                                        className={`text-center rounded !text-xs p-1 whitespace-nowrap ${estadosSalidaOrdenTrabajo[data.codEstadoSuministroAlmacen]}`}
                                                    >
                                                        {capitalLetter(data.nomEstadoSuministroAlmacen) || "-"}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                            ) : (
                                <tr><td colSpan={9} className="text-center">No hay información con los parametros seleccionados...</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <Modal
                    title={"Salida de almacén por OT"}
                    isOpen={isOpenSalidaOT}
                    action={funcionConfirmarSalidaPorOT}
                    closeModal={closeSalidaOT}
                >
                    <div className="w-[700px] lg:w-full flex flex-col gap-4 px-4">
                        <fieldset className="border rounded p-4">
                            <legend>Datos OT</legend>
                            <div className="grid grid-cols-2 lg:grid-cols-1 gap-[100px] lg:gap-2">
                                <div className="grid grid-cols-3 gap-2">
                                    <i
                                        className="col-span-1 fa fa-calendar text-sm"
                                        aria-hidden="true"
                                    ></i>
                                    <input
                                        defaultValue={
                                            movimientoInfo.fechaOrdenTrabajo
                                        }
                                        disabled
                                        className={`${classNameInput} col-span-2`}
                                    />
                                    <i
                                        className="col-span-1 fa fa-bus text-sm"
                                        aria-hidden="true"
                                    ></i>
                                    <select
                                        defaultValue={movimientoInfo.codUnidad}
                                        disabled
                                        className={`${classNameInput} col-span-2`}
                                    >
                                        {unidadesActivas.map((data, i) => (
                                            <option
                                                key={i + 1}
                                                value={data.codUnidad}
                                            >
                                                {data.nomUnidad}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="grid grid-cols-3 gap-2">
                                    <span className="col-span-1">Código</span>
                                    <input
                                        defaultValue={
                                            movimientoInfo.numDocumentoOT
                                        }
                                        disabled
                                        className={`${classNameInput} col-span-2`}
                                    />
                                    <i
                                        className="col-span-1 fa fa-user text-sm"
                                        aria-hidden="true"
                                    ></i>
                                    <select
                                        defaultValue={
                                            movimientoInfo.codPersonaConductor
                                        }
                                        disabled
                                        className={`${classNameInput} col-span-2`}
                                    >
                                        {conductores.map((data, i) => (
                                            <option
                                                key={i + 1}
                                                value={data.codPersona}
                                            >
                                                {data.nomPersona}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="border rounded p-4">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nº</th>
                                        <th>ARTÍCULO</th>
                                        <th>CANTIDAD</th>
                                        <th>SERIE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {movimientoInfo.repuestoDetalle
                                        ?.split("~") // SEPARA LOS PRODUCTOS
                                        .map((data, i) => {
                                            const partes = data.split("*"); // SEPARA LAS CARACTERISTICAS DE LOS PRODUCTOS
                                            /*
                                                partes -> codProducto*nomProducto*descripcionProducto*cantidadSolicitada*tieneSerie*_*seriesConcatenadasConComas
                                            */
                                            const seriesRegistradas = partes[6]
                                                ? partes[6]
                                                      .split(",")
                                                      .reduce(
                                                          (
                                                              acumulador,
                                                              data,
                                                              index
                                                          ) => {
                                                              acumulador[
                                                                  index
                                                              ] = data;
                                                              return acumulador;
                                                          },
                                                          {}
                                                      )
                                                : {};

                                            return (
                                                <tr key={i + 1}>
                                                    <td className="text-center">
                                                        {i + 1}
                                                    </td>
                                                    <td className="text-center">
                                                        {partes[1]}
                                                    </td>
                                                    <td className="text-center">
                                                        {partes[3]}
                                                    </td>
                                                    <td className="text-center">
                                                        {partes[4] == 1 ? (
                                                            <i
                                                                onClick={() => {
                                                                    setCodigoProdSeleccionadoSerie(
                                                                        partes[0]
                                                                    );
                                                                    setSeriesModalSalida(
                                                                        seriesRegistradas
                                                                    );
                                                                    openModalSeriesSalida();
                                                                    listarSeriesNeumaticosConMedida(partes[0])
                                                                }}
                                                                className="fa fa-barcode"
                                                                aria-hidden="true"
                                                            ></i>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </fieldset>
                        <fieldset className="border rounded p-4">
                            <legend>Comentario</legend>
                            <textarea
                                placeholder="(Comentario)"
                                value={movimientoInfo.comentario}
                                onChange={(e) =>
                                    editarValorMovimientoInfo(
                                        "comentario",
                                        e.target.value
                                    )
                                }
                                className={`${classNameInput} h-[80px] p-2`}
                            ></textarea>
                        </fieldset>
                        <fieldset className="border rounded p-4">
                            <legend>Datos solicitante</legend>
                            <div className="flex gap-4 items-center">
                                <i
                                    className="col-span-1 fa fa-user text-sm"
                                    aria-hidden="true"
                                ></i>
                                <select
                                    className={classNameInput}
                                    value={movimientoInfo.codSolicitante}
                                    onChange={(e) =>
                                        editarValorMovimientoInfo(
                                            "codSolicitante",
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value={0}>--Seleccione--</option>
                                    {personasTaller.map((data, i) => (
                                        <option
                                            key={i + 1}
                                            value={data.codPersona}
                                        >
                                            {data.nomPersona}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </fieldset>
                    </div>
                </Modal>

                <Modal
                    title={"Series salida producto"}
                    isOpen={isOpenModalSeriesSalida}
                    closeModal={closeModalSeriesSalida}
                    action={() => {
                        const series = Object.values(seriesModalSalida);
                        const seriesConcatenadas = series.join(",");
                        let cantidadSeries = 0;
                        const repuestoDetalleModificado =
                            movimientoInfo.repuestoDetalle
                                ?.split("~")
                                .map((data, i) => {
                                    const partes = data.split("*");
                                    if (
                                        partes[0] == codigoProdSeleccionadoSerie
                                    ) {
                                        cantidadSeries = partes[3];
                                        if (partes[6]) {
                                            partes[6] = seriesConcatenadas;
                                            return partes.join("*");
                                        } else {
                                            return (
                                                data + "*" + seriesConcatenadas
                                            );
                                        }
                                    } else {
                                        return data;
                                    }
                                })
                                .join("~");

                        if (cantidadSeries == series.length) {
                            editarValorMovimientoInfo(
                                "repuestoDetalle",
                                repuestoDetalleModificado
                            );
                            notify("Series agregadas correctamente", "success");
                            closeModalSeriesSalida();
                        } else {
                            notify(
                                "El numero de series registradas no coincide con el numero de repuestos",
                                "error"
                            );
                        }
                    }}
                >
                    <div className="w-full p-5 max-h-[200px] overflow-auto containerScroll flex justify-center">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-center">Nº</th>
                                    <th className="text-center">SERIE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({
                                    length: Number(
                                        movimientoInfo.repuestoDetalle
                                            ?.split("~")
                                            .find(
                                                (e) =>
                                                    e?.split("*")[0] ==
                                                    codigoProdSeleccionadoSerie
                                            )
                                            ?.split("*")[3]
                                    ),
                                }).map((_, i) => {
                                    return (
                                        <tr key={i + 1}>
                                            <td>{i + 1}</td>
                                            <td>
                                                {/* <input 
                                                        value={seriesModalSalida[i]} 
                                                        onChange={e => setSeriesModalSalida(valoresAnteriores => {
                                                            return {
                                                                ...valoresAnteriores,
                                                                [i]: e.target.value
                                                            }
                                                        })} 
                                                        className={classNameInput} 
                                                        type='text' 
                                                    /> */}
                                                <select
                                                    className={classNameInput}
                                                    value={seriesModalSalida[i]}
                                                    onChange={(e) => {
                                                        if (Object.values(seriesModalSalida).some((elem) =>elem ==e.target.value)) {
                                                            notify(
                                                                "La serie elegida ya fue seleccionada",
                                                                "info"
                                                            );
                                                        } else {
                                                            setSeriesModalSalida((valoresAnteriores) => {
                                                                    return {
                                                                        ...valoresAnteriores,
                                                                        [i]: e
                                                                            .target
                                                                            .value,
                                                                    };
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <option value="0">
                                                        --Seleccione--
                                                    </option>
                                                    {seriesNeumaticosConMedida
                                                        .filter((e) => !Object.values(seriesModalSalida).filter((elem) => elem != seriesModalSalida[i]).map(Number).includes(Number(e.codAlmacenRepuestoSerie)))
                                                        .map((data, i) => (
                                                            <option
                                                                key={i + 1}
                                                                value={data.codAlmacenRepuestoSerie}
                                                            >
                                                                {data.serieRepuesto}
                                                            </option>
                                                        ))}
                                                </select>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </Modal>
            </div>
        </>
    );
};
